import {
  CalendarIcon_default
} from "./chunk-BAG5INDR.mjs";
export {
  CalendarIcon_default as default
};
